import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useLanguage } from '../context/LanguageContext';

// Κανονικοποίηση στο μεσημέρι ώστε η ημέρα που διάλεξε ο χρήστης να μην αλλάζει (timezone-safe)
function toNoonCalendarDate(date) {
  if (!date) return date;
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0);
}

const CalendarPopup = ({ calendarOpen, setCalendarOpen, selectedDates, setSelectedDates, getAirbnbUrl, getBookingUrl, getYourRentalsUrl, openInNewTab }) => {
  const { t } = useLanguage();

  const handleCalendarChange = (value) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      setSelectedDates([toNoonCalendarDate(value[0]), toNoonCalendarDate(value[1])]);
    } else {
      setSelectedDates(value);
    }
  };

  // Άνοιγμα link τη στιγμή του κλικ ώστε να περνούν πάντα οι τρέχουσες ημερομηνίες (όχι stale href)
  const handleBookingClick = (e, getUrl) => {
    e.preventDefault();
    const url = getUrl();
    if (openInNewTab) openInNewTab(url);
    else window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!calendarOpen) {
    return (
      <button
        onClick={() => setCalendarOpen(true)}
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-blue-600 hover:bg-cyan-500 text-white rounded-full shadow-lg p-4 sm:p-5 flex items-center justify-center transition-all duration-200"
        aria-label={t('calendar.title')}
      >
        <svg width="28" height="28" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="4" fill="white"/><rect x="3" y="4" width="18" height="18" rx="4" stroke="#2563eb" strokeWidth="2"/><rect x="7" y="2" width="2" height="4" rx="1" fill="#2563eb"/><rect x="15" y="2" width="2" height="4" rx="1" fill="#2563eb"/><rect x="7" y="10" width="2" height="2" rx="1" fill="#2563eb"/><rect x="11" y="10" width="2" height="2" rx="1" fill="#2563eb"/><rect x="15" y="10" width="2" height="2" rx="1" fill="#2563eb"/><rect x="7" y="14" width="2" height="2" rx="1" fill="#2563eb"/><rect x="11" y="14" width="2" height="2" rx="1" fill="#2563eb"/><rect x="15" y="14" width="2" height="2" rx="1" fill="#2563eb"/></svg>
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-50 w-[95vw] max-w-xs sm:max-w-[340px] bg-white rounded-2xl shadow-2xl border border-blue-100 p-3 sm:p-6 flex flex-col items-center animate-fade-in">
      <button
        onClick={() => setCalendarOpen(false)}
        className="absolute top-2 right-3 sm:top-3 sm:right-4 text-xl sm:text-2xl text-gray-400 hover:text-blue-600 transition"
        aria-label={t('calendar.close')}
      >
        &times;
      </button>
      <h2 className="text-lg sm:text-xl font-bold mb-2 sm:mb-4 text-blue-900 text-center">{t('calendar.title')}</h2>
      <Calendar
        className="rounded-xl shadow border border-blue-100 w-full"
        tileClassName={() => 'text-base'}
        selectRange={true}
        onChange={handleCalendarChange}
        value={selectedDates}
      />
      <a
        href={getAirbnbUrl()}
        onClick={(e) => handleBookingClick(e, getAirbnbUrl)}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-4 sm:mt-6 w-full font-bold py-2 sm:py-3 rounded-xl text-base sm:text-lg shadow transition-all duration-200 text-center bg-blue-600 hover:bg-cyan-500 text-white cursor-pointer"
        style={{ textDecoration: 'none' }}
      >
        {t('calendar.bookAirbnb')}
      </a>
      <a
        href={getBookingUrl()}
        onClick={(e) => handleBookingClick(e, getBookingUrl)}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 sm:mt-3 w-full font-bold py-2 sm:py-3 rounded-xl text-base sm:text-lg shadow transition-all duration-200 text-center bg-[#003580] hover:bg-blue-800 text-white cursor-pointer"
        style={{ textDecoration: 'none' }}
      >
        {t('calendar.bookBooking')}
      </a>
      {getYourRentalsUrl && (
        <a
          href={getYourRentalsUrl()}
          onClick={(e) => handleBookingClick(e, getYourRentalsUrl)}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 sm:mt-3 w-full font-bold py-2 sm:py-3 rounded-xl text-base sm:text-lg shadow transition-all duration-200 text-center bg-[#00B4A0] hover:bg-teal-600 text-white cursor-pointer"
          style={{ textDecoration: 'none' }}
        >
          {t('calendar.bookYourRentals')}
        </a>
      )}
      <a
        href="tel:+306983446269"
        className="mt-2 sm:mt-3 w-full font-bold py-2 sm:py-3 rounded-xl text-base sm:text-lg shadow transition-all duration-200 text-center bg-cyan-600 hover:bg-blue-500 text-white cursor-pointer"
        style={{ textDecoration: 'none' }}
      >
        {t('calendar.requestQuote')}
      </a>
    </div>
  );
};

export default CalendarPopup; 